import type { VoidComponent } from "solid-js";
import type { ISOCurrency } from "../../currency";
import { useTranslation } from "../../state/i18n";
import withErrorBoundary from "../../utils/withErrorBoundary";

const FormatCurrency: VoidComponent<{ value: number; currency: keyof typeof ISOCurrency }> = (props) => {
  // It would be better to use the actual locale of the user, but unfortunately, we don't have it. The next best thing
  // is to base the formatting on the selected language
  const { currentLanguage } = useTranslation();

  return (
    <>{new Intl.NumberFormat(currentLanguage(), { style: "currency", currency: props.currency }).format(props.value)}</>
  );
};

// Not all currencies listed in 'ISOCurrency' are supported by 'Intl.NumberFormat'. Therefor catch any formatting errors
// and just return the raw currency and value.
//
// Unsupported currencies at the time of writing: CKD, EHP, FOK, GGP, IMP, JEP, KID, PND, PRB, SLS, TVD, VED, unknown
const FormatCurrencyWithErrorBoundary = withErrorBoundary(FormatCurrency, (props) => (
  <>
    `${props.currency} ${props.value}`
  </>
));

export default FormatCurrencyWithErrorBoundary;
